export default __webpack_public_path__ + "static/media/piece-move-sound-low.f3e8e1f5.mp3";